// AS1851:2012 Service Routines and Checklists

export const AS1851_ROUTINES = {
  '6-MONTHLY': {
    label: '6-Monthly Service',
    description: 'Standard 6-month inspection (AS1851:2012)',
    categories: ['Fire Extinguishers', 'Fire Hose Reels', 'Emergency Lighting']
  },
  'ANNUAL': {
    label: 'Annual Service',
    description: 'Annual inspection and testing (AS1851:2012)',
    categories: ['Fire Extinguishers', 'Fire Hose Reels', 'Fire Hydrants', 'Emergency Lighting']
  },
  '5-YEAR': {
    label: '5-Year Service',
    description: '5-year extended inspection (AS1851:2012)',
    categories: ['Fire Extinguishers', 'Fire Hose Reels']
  },
  'HYDROSTATIC': {
    label: 'Hydrostatic Test',
    description: 'Hydrostatic pressure testing (AS1851:2012)',
    categories: ['Fire Extinguishers', 'Fire Hose Reels']
  }
};

export const AS1851_CHECKLISTS = {
  '6-MONTHLY': {
    'Fire Extinguishers': [
      { item: 'Location and accessibility check', compliant: true },
      { item: 'Signage and identification visible', compliant: true },
      { item: 'Physical condition of cylinder', compliant: true },
      { item: 'Pressure gauge reading within green zone', compliant: true },
      { item: 'Safety pin and tamper seal intact', compliant: true },
      { item: 'Hose and nozzle condition check', compliant: true },
      { item: 'Operating instructions legible', compliant: true },
      { item: 'Service tag attached and current', compliant: true },
      { item: 'Weight check (CO2 units)', compliant: true },
      { item: 'No visible damage or corrosion', compliant: true }
    ],
    'Fire Hose Reels': [
      { item: 'Location and accessibility check', compliant: true },
      { item: 'Signage clearly visible', compliant: true },
      { item: 'Hose reel cabinet condition', compliant: true },
      { item: 'Hose condition (no cracks or damage)', compliant: true },
      { item: 'Nozzle operation and condition', compliant: true },
      { item: 'Guide rollers rotate freely', compliant: true },
      { item: 'Swivel joint operation', compliant: true },
      { item: 'Drum rotation smooth', compliant: true },
      { item: 'Stop valve operation', compliant: true },
      { item: 'Service tag attached', compliant: true }
    ],
    'Emergency Lighting': [
      { item: 'Location and visibility check', compliant: true },
      { item: 'Lamp operation test', compliant: true },
      { item: 'Battery backup test (90 minutes)', compliant: true },
      { item: 'Lens and housing condition', compliant: true },
      { item: 'Test button operation', compliant: true },
      { item: 'Charging indicator functional', compliant: true },
      { item: 'Exit sign illumination', compliant: true },
      { item: 'Mounting secure', compliant: true },
      { item: 'No physical damage', compliant: true },
      { item: 'Service label attached', compliant: true }
    ]
  },
  'ANNUAL': {
    'Fire Extinguishers': [
      { item: 'All 6-monthly checks completed', compliant: true },
      { item: 'Discharge test (sample basis)', compliant: true },
      { item: 'Internal inspection (where applicable)', compliant: true },
      { item: 'Pressure vessel inspection', compliant: true },
      { item: 'Weighing and recording', compliant: true },
      { item: 'Valve and operating mechanism check', compliant: true },
      { item: 'Hose and coupling pressure test', compliant: true },
      { item: 'Refill or recharge if required', compliant: true },
      { item: 'New service tag attached', compliant: true },
      { item: 'Test certificate issued', compliant: true }
    ],
    'Fire Hose Reels': [
      { item: 'All 6-monthly checks completed', compliant: true },
      { item: 'Full hose extension test', compliant: true },
      { item: 'Flow and pressure test', compliant: true },
      { item: 'Leak test at all connections', compliant: true },
      { item: 'Hose integrity test', compliant: true },
      { item: 'Nozzle pattern test', compliant: true },
      { item: 'Stop valve full operation test', compliant: true },
      { item: 'Guide assembly inspection', compliant: true },
      { item: 'Mounting bracket security check', compliant: true },
      { item: 'New service tag attached', compliant: true }
    ],
    'Fire Hydrants': [
      { item: 'Location and accessibility check', compliant: true },
      { item: 'Signage clearly visible', compliant: true },
      { item: 'Cabinet and door condition', compliant: true },
      { item: 'Hose coupling condition', compliant: true },
      { item: 'Valve operation test', compliant: true },
      { item: 'Flow test (where required)', compliant: true },
      { item: 'Pressure test', compliant: true },
      { item: 'Branch and nozzle condition', compliant: true },
      { item: 'All equipment present', compliant: true },
      { item: 'Service tag attached', compliant: true }
    ],
    'Emergency Lighting': [
      { item: 'All 6-monthly checks completed', compliant: true },
      { item: 'Full duration test (90 minutes minimum)', compliant: true },
      { item: 'Battery load test', compliant: true },
      { item: 'Charger output test', compliant: true },
      { item: 'Lamp intensity test', compliant: true },
      { item: 'Complete recharge test', compliant: true },
      { item: 'All connections secure', compliant: true },
      { item: 'Test records updated', compliant: true },
      { item: 'Battery replacement if required', compliant: true },
      { item: 'New service label attached', compliant: true }
    ]
  },
  '5-YEAR': {
    'Fire Extinguishers': [
      { item: 'Complete discharge and internal inspection', compliant: true },
      { item: 'Cylinder hydrostatic pressure test', compliant: true },
      { item: 'Valve body inspection and test', compliant: true },
      { item: 'Hose hydrostatic test', compliant: true },
      { item: 'Thread inspection and repair', compliant: true },
      { item: 'O-ring and seal replacement', compliant: true },
      { item: 'Complete refill with new agent', compliant: true },
      { item: 'Pressure test after refill', compliant: true },
      { item: 'New service tag and stamp', compliant: true },
      { item: 'Extended test certificate issued', compliant: true }
    ],
    'Fire Hose Reels': [
      { item: 'Complete hose replacement', compliant: true },
      { item: 'Pressure test at 2x working pressure', compliant: true },
      { item: 'All couplings replaced', compliant: true },
      { item: 'Valve servicing and seal replacement', compliant: true },
      { item: 'Swivel joint overhaul', compliant: true },
      { item: 'Drum bearing inspection', compliant: true },
      { item: 'Cabinet refurbishment', compliant: true },
      { item: 'Complete system flush', compliant: true },
      { item: 'New service tag attached', compliant: true },
      { item: 'Extended test certificate issued', compliant: true }
    ]
  },
  'HYDROSTATIC': {
    'Fire Extinguishers': [
      { item: 'Complete discharge of unit', compliant: true },
      { item: 'Internal cleaning and inspection', compliant: true },
      { item: 'Visual inspection for damage', compliant: true },
      { item: 'Test rig setup and calibration', compliant: true },
      { item: 'Hydrostatic pressure test (1.5x working pressure)', compliant: true },
      { item: 'Hold pressure for 60 seconds', compliant: true },
      { item: 'Visual inspection during test', compliant: true },
      { item: 'Pressure release and inspection', compliant: true },
      { item: 'Drying and reassembly', compliant: true },
      { item: 'Test stamp and certification', compliant: true }
    ],
    'Fire Hose Reels': [
      { item: 'Hose disconnected from system', compliant: true },
      { item: 'Visual pre-test inspection', compliant: true },
      { item: 'Test rig connection and sealing', compliant: true },
      { item: 'Gradual pressure increase', compliant: true },
      { item: 'Test pressure (2x working pressure)', compliant: true },
      { item: 'Hold for specified duration', compliant: true },
      { item: 'Check for leaks and bulging', compliant: true },
      { item: 'Pressure release and drain', compliant: true },
      { item: 'Post-test visual inspection', compliant: true },
      { item: 'Test certification and marking', compliant: true }
    ]
  }
};

export const getChecklistForRoutine = (routine, category) => {
  const checklist = AS1851_CHECKLISTS[routine]?.[category] || [];
  return checklist.map(item => ({ ...item })); // Return a copy
};

export const getAllCategories = () => {
  return [
    'Fire Extinguishers',
    'Fire Hose Reels',
    'Fire Hydrants',
    'Emergency Lighting',
    'Fire Sprinkler',
    'Smoke Detector',
    'Fire Alarm Panel'
  ];
};
